/* global CAROUSEL_LOGOS */

document.addEventListener('DOMContentLoaded', function () {
  var carousel = document.getElementById('logo-carousel');
  var carouselContainer = document.getElementById('logo-carousel-container');
  var scrollLeftBtn = document.getElementById('logo-carousel-scroll-left');
  var scrollRightBtn = document.getElementById('logo-carousel-scroll-right');

  if (!carousel || !carouselContainer) {
    return;
  }

  if (!CAROUSEL_LOGOS || CAROUSEL_LOGOS.length === 0) {
    carousel.remove();
    return;
  }

  var shouldScroll = true;
  var lastScrollPos = 0;
  var supportsScrollBy = typeof(carouselContainer.scrollBy) === 'function';

  var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

  // Pause scroll on mouse over.
  carousel.addEventListener("mouseenter", function () { 
    if (!supportsScrollBy) {
      return;
    }

    shouldScroll = false; 
    lastScrollPos = carouselContainer.scrollLeft;
  });


  carousel.addEventListener("mouseleave", function () { 
    if (!supportsScrollBy) {
      return;
    }

    shouldScroll = true;

    if (isSmoothScrollSupported) {
      carouselContainer.scrollTo({ top: 0, left: lastScrollPos, behavior: 'smooth' });
    } else {
      carouselContainer.scrollTo({ top: 0, left: lastScrollPos });
    }
  });

  // How often setInterval runs in ms.
  var scrollInterval = 50;
  // The amount of scroll to apply each time setInterval runs.
  var scrollTickAmount = 2;

  var firstElementIndex = 0;
  var lastElementIndex = CAROUSEL_LOGOS.length - 1;
  var logoAmountLimit = CAROUSEL_LOGOS.length;


  // Make the element static if window.scrollBy is not defined.
  if (!supportsScrollBy) {
    logoAmountLimit = 10;
    shouldScroll = false;

    if (scrollRightBtn !== null) {
      scrollRightBtn.remove();
    }

    if (scrollLeftBtn !== null) {
      scrollLeftBtn.remove();
    }

    carouselContainer.classList.remove('b2b__logo-carousel--container');
    carouselContainer.classList.add('b2b__logo-carousel--container-static');
    carousel.classList.remove('grid__cell--flex');
    carousel.classList.remove('grid__cell--space-between');
  }

  // Create the image elements.
  for (var i = 0; i < logoAmountLimit; i++) {
    var logo = CAROUSEL_LOGOS[i];

    var el = document.createElement('img');
    el.setAttribute('src', logo);
    el.setAttribute('alt', '');
    el.setAttribute('id', "logo-img-" + i);

    carouselContainer.appendChild(el);
  }

  // All code after this point assumes element.scrollBy is defined.
  if (!supportsScrollBy) {
    return;
  }

  // Apply scroll over time.
  setInterval(function () {
    if (shouldScroll) {
      carouselContainer.scrollBy(scrollTickAmount, 0);

      if (carouselContainer.scrollWidth === carouselContainer.clientWidth) {
        return;
      }

      var firstEl = document.getElementById("logo-img-" + firstElementIndex);
      if (firstEl === null) {
        return;
      }
      
      // Check if the left-most image was hidden by scroll.
      var elementRight = firstEl.getBoundingClientRect().right;
      var containerLeft = carouselContainer.getBoundingClientRect().left;

      if (elementRight + 10 <= containerLeft) {
        // Remove the image that was just hidden by scroll
        var toRemove = document.getElementById("logo-img-" + firstElementIndex);
        if (toRemove !== null) {
          toRemove.remove();
        }

        // Create a new image at the end of the logo list.
        var el = document.createElement('img');
        el.setAttribute('src', CAROUSEL_LOGOS[firstElementIndex]);
        el.setAttribute('alt', '');
        el.setAttribute('id', "logo-img-" + firstElementIndex);

        carouselContainer.appendChild(el);

        carouselContainer.scrollTo(0, 0);

        firstElementIndex++;

        if (firstElementIndex > lastElementIndex) {
          firstElementIndex = 0;
        }
      }
    }
  }, scrollInterval);


  if (scrollLeftBtn === null || scrollRightBtn === null) {
    return;
  }

  var scrollAmount = 90;

  function scrollLeft() {
    if (isSmoothScrollSupported) {
      carouselContainer.scrollBy({ top: 0, left: -scrollAmount, behavior: 'smooth' });
    } else {
      carouselContainer.scrollBy({ top: 0, left: -scrollAmount});
    }
  }

  function scrollRight() {
    if (isSmoothScrollSupported) {
      carouselContainer.scrollBy({ top: 0, left: scrollAmount, behavior: 'smooth' });
    } else {
      carouselContainer.scrollBy({ top: 0, left: scrollAmount});
    }
  }

  scrollLeftBtn.addEventListener('click', scrollLeft);
  scrollRightBtn.addEventListener('click', scrollRight);

});
